import { ref } from "vue";

const isOpen = ref(false);
const selectedMemberId = ref<string | null>(null);

export function useMemberProfile() {
  function openMemberProfile(memberId: string) {
    selectedMemberId.value = memberId;
    // Use requestAnimationFrame to ensure the transition triggers properly
    // This gives the browser time to render the component before setting isOpen to true
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        isOpen.value = true;
      });
    });
  }

  function closeMemberProfile() {
    isOpen.value = false;
    // Don't clear memberId immediately to allow smooth close animation
    setTimeout(() => {
      selectedMemberId.value = null;
    }, 300);
  }

  return {
    isOpen,
    selectedMemberId,
    openMemberProfile,
    closeMemberProfile,
  };
}
